import React from 'react';
import { useTranslation } from 'react-i18next';
import { Trash16 } from 'shared/assets/icons';

import { MetaInteraction } from '../meta-interaction';

export type MetaDeleteHabitProps = {
  onDelete: () => void;
};

export const MetaDeleteHabit: React.FC<MetaDeleteHabitProps> = ({
  onDelete,
}) => {
  const { t } = useTranslation();

  return (
    <MetaInteraction
      icon={Trash16}
      label={t('general.labels.delete')}
      placeholder={t('general.labels.delete')}
      onClick={onDelete}
    />
  );
};
